var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maijia_head"},[_c('img',{attrs:{"src":require("../assets/images/maijia_logo.png"),"alt":""}}),_c('p',{on:{"click":_vm.handleLangChange}},[_vm._v(_vm._s(_vm.$i18n.locale == 'en'?'中文':'EN'))])])}
var staticRenderFns = []

export { render, staticRenderFns }